import React, { Component } from 'react';
class EventList extends Component {
  constructor() {
    super();
    this.state = {
      event_list:'',
    };
  }

componentDidMount(){
    var event_list = [];
    var event_month = this.props.event_month;
    var check_event_is = 0;
    for(var i in event_month){
      var list = event_month[i];
      if(list.length){
        for(var j=0; j<list.length;j++){
          var data = list[j]['data'];
          var event_title = data['event_title'];
          var envet_from_date = this.formatNewDate(data['envet_from_date']);
          var envet_from_time = data['envet_from_time'];
          var envet_to_date = this.formatNewDate(data['envet_to_date']);
          var envet_to_time = data['envet_to_time'];
          var from_date = envet_from_date+" "+window.formatTime(envet_from_time);
          var to_date = envet_to_date+" "+window.formatTime(envet_to_time);
          event_list.push(<p className="ms-4">{event_title.substring(0,20)+" ("+from_date+" to "+to_date+")"}</p>);
        }
        check_event_is = 1;
      }
    }
    if(check_event_is==0){event_list.push(<p className="ms-4">No Event</p>);}
    this.setState({event_list});
}
formatNewDate(date_str){
  var parts = date_str.split('-');
  var day = parts[2];
  var month = parseInt(parts[1]);
  var year = parseInt(parts[0]);
  var monthNames = ["","Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var formattedDate = day+"-"+monthNames[month]+"-"+year;
  return formattedDate;
}

  render() {
    return (
        <>
        <div className="col-md-4">
          <div className="container mt-4">
            <div className="accordion" id="EventspryTabs">
              <div className="accordion-item" id="tab-2">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#EventList" aria-expanded="true" aria-controls="collapseOne">
                    Event List
                  </button>
                </h2>
                <div id="EventList" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#EventspryTabs">
                  <div className="accordion-body background-white calendar_card">
                  {this.state.event_list}
                  </div>
                </div>
                </div>
                </div>
          </div>
        </div>

        </>
    );
  }
}

export default EventList;
